//@flow
export const GET_APOLLO_XML_COUNT_RPT_DATA='GET_APOLLO_XML_COUNT_RPT_DATA';
export const GET_APOLLO_XML_COUNT_RPT_DATA_ERROR='GET_APOLLO_XML_COUNT_RPT_DATA_ERROR';
export const GET_APOLLO_XML_COUNT_BATCH_DATA='GET_APOLLO_XML_COUNT_BATCH_DATA';
export const GET_APOLLO_XML_COUNT_BATCH_DATA_ERROR='GET_APOLLO_XML_COUNT_BATCH_DATA_ERROR';
export const GET_APOLLO_XML_COUNT_BATCH_WORKER_DATA='GET_APOLLO_XML_COUNT_BATCH_WORKER_DATA';
export const GET_APOLLO_XML_COUNT_BATCH_WORKER_DATA_ERROR='GET_APOLLO_XML_COUNT_BATCH_WORKER_DATA_ERROR';
export const TRIGGER_APOLLO_XML_COUNT_REPORT='TRIGGER_APOLLO_XML_COUNT_REPORT';


// WEBPACK FOOTER //
// ./src/redux/apolloXmlCount/actionTypes.js